import { render, staticRenderFns } from "./CabinetTransferDetail.vue?vue&type=template&id=88e9f6ee&scoped=true&"
import script from "./CabinetTransferDetail.vue?vue&type=script&lang=js&"
export * from "./CabinetTransferDetail.vue?vue&type=script&lang=js&"
import style0 from "./CabinetTransferDetail.vue?vue&type=style&index=0&id=88e9f6ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88e9f6ee",
  null
  
)

export default component.exports